"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FlowSectionComponent = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _stepState = require("../../constants/stepState.constants");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      marginBottom: theme.spacing(2),
      paddingLeft: 28
    },
    wrapper: {
      position: 'relative',
      padding: theme.spacing(2),
      paddingLeft: theme.spacing(6),
      border: "2px solid ".concat(theme.palette.divider),
      borderRadius: 5
    },
    active: {
      padding: 0,
      border: "2px solid #15998c"
    },
    passed: {
      minHeight: 99
    },
    avatar: {
      width: 62,
      height: 62,
      position: 'absolute',
      top: 16,
      left: -31,
      border: "4px solid ".concat(theme.palette.common.white),
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: '#a4cba4',
      color: theme.palette.common.white,
      zIndex: 2
    },
    disabledAvatar: {
      width: 30,
      height: 30,
      position: 'absolute',
      left: -15,
      top: 13,
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: theme.palette.divider,
      color: theme.palette.common.white
    },
    disabledIcon: {
      color: theme.palette.grey.main
    },
    icon: {
      fontSize: '14px',
      margin: '0px 5px 0px 10px'
    },
    activeAvatar: {
      backgroundColor: '#44ada3'
    },
    checkMark: {
      position: 'absolute',
      top: 56,
      left: 9,
      width: 22,
      height: 22,
      border: "2px solid ".concat(theme.palette.common.white),
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
      backgroundColor: '#4a974a',
      zIndex: 3
    },
    checkMarkIcon: {
      color: theme.palette.common.white,
      fontSize: 10
    },
    passedIcon: {
      fontSize: '2rem'
    },
    title: {
      textTransform: 'uppercase',
      flexGrow: 1
    }
  };
});

var FlowSectionComponent = function FlowSectionComponent(_ref) {
  var state = _ref.state,
      title = _ref.title,
      details = _ref.details,
      value = _ref.value,
      icon = _ref.icon,
      image = _ref.image,
      showEdit = _ref.showEdit,
      renderActive = _ref.renderActive,
      renderPassed = _ref.renderPassed,
      renderDetails = _ref.renderDetails,
      onEdit = _ref.onEdit,
      zIndex = _ref.zIndex,
      disabled = _ref.disabled,
      isValueLink = _ref.isValueLink;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showDetails = _useState2[0],
      setShowDetails = _useState2[1];

  var renderPassedState = (0, _react.useCallback)(function () {
    return /*#__PURE__*/_react.default.createElement(_material.Grid, {
      className: (0, _classnames.default)(classes.wrapper, classes.passed)
    }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
      className: classes.avatar,
      src: image
    }, icon && /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      className: classes.passedIcon,
      color: "inherit",
      icon: icon
    })), /*#__PURE__*/_react.default.createElement(_material.Avatar, {
      className: classes.checkMark
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      icon: "check",
      className: classes.checkMarkIcon
    })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      container: true,
      justifyContent: "space-between",
      alignItems: "baseline",
      direction: "row"
    }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: (0, _classnames.default)('Label-Table-Left-Static', classes.title)
    }, title), details && /*#__PURE__*/_react.default.createElement(_material.Button, {
      size: "small",
      disableRipple: true,
      variant: "text",
      className: "Button-Link",
      onClick: function onClick() {
        return setShowDetails(!showDetails);
      }
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      className: classes.icon,
      color: "inherit",
      icon: "info-circle"
    }), details), showEdit && /*#__PURE__*/_react.default.createElement(_material.Button, {
      size: "small",
      disabled: disabled,
      disableRipple: true,
      variant: "text",
      className: "Button-Link",
      onClick: onEdit
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      className: classes.icon,
      color: "inherit",
      icon: "pencil"
    }), "Edit")), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      noWrap: true,
      className: "H3-Chambray"
    }, value && /*#__PURE__*/_react.default.createElement(_ui.TableCellTooltip, {
      isValueLink: isValueLink,
      lengthToShow: 40,
      title: value
    })), renderPassed(), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
      in: showDetails
    }, renderDetails()));
  }, [image, renderPassed, icon, value, title, showDetails, showEdit, disabled, classes, details, isValueLink, onEdit, renderDetails]);

  if (state === _stepState.stepState.HIDDEN) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_material.Slide, {
    direction: "left",
    in: state !== _stepState.stepState.HIDDEN,
    style: {
      zIndex
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.root
  }, state === _stepState.stepState.PASSED && renderPassedState(), state === _stepState.stepState.ACTIVE && /*#__PURE__*/_react.default.createElement(_material.Paper, {
    elevation: 1,
    className: (0, _classnames.default)(classes.wrapper, classes.active)
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    className: (0, _classnames.default)(classes.avatar, classes.activeAvatar)
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    className: classes.passedIcon,
    color: "inherit",
    icon: icon
  })), renderActive()), state === _stepState.stepState.DISABLED && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    className: classes.disabledAvatar
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    className: classes.disabledIcon,
    icon: icon
  })), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)('Body-Regular-Left-Inactive')
  }, title))));
};

exports.FlowSectionComponent = FlowSectionComponent;
FlowSectionComponent.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  value: _propTypes.default.node,
  isValueLink: _propTypes.default.bool,
  icon: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  image: _propTypes.default.string,
  renderActive: _propTypes.default.func,
  renderPassed: _propTypes.default.func,
  renderDetails: _propTypes.default.func,
  state: _propTypes.default.oneOf([_stepState.stepState.ACTIVE, _stepState.stepState.DISABLED, _stepState.stepState.PASSED, _stepState.stepState.HIDDEN]).isRequired,
  showEdit: _propTypes.default.bool,
  onEdit: _propTypes.default.func,
  details: _propTypes.default.string,
  zIndex: _propTypes.default.number,
  disabled: _propTypes.default.bool
};
FlowSectionComponent.defaultProps = {
  renderActive: function renderActive() {
    return null;
  },
  renderPassed: function renderPassed() {
    return null;
  },
  onEdit: function onEdit() {
    return null;
  },
  renderDetails: function renderDetails() {
    return null;
  },
  icon: null,
  image: null,
  title: '',
  value: '',
  isValueLink: false,
  showEdit: false,
  details: '',
  zIndex: 0,
  disabled: false
};
var _default = FlowSectionComponent;
exports.default = _default;